// extracted by mini-css-extract-plugin
export var blockTitle = "documents-module--blockTitle--e3397";
export var fadeInAnimation = "documents-module--fadeInAnimation--ebcad";
export var icon = "documents-module--icon--2f148";
export var link = "documents-module--link--70eaf";
export var title = "documents-module--title--9c358";
export var wrapper = "documents-module--wrapper--1bbc5";